import { DropdownOption } from "../Dropdown/types";

/** Suženje popisa na jednu vrstu kontakta; prazno = i tvrtke i osobe. */
export enum ContactDropdownTypeEnum {
  COMPANY = "company",
  PERSON = "person",
}

export type ContactDropdownProps = {
  name: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  error?: string;
  value?: any;
  direction?: "up" | "down" | "left" | "right";
  width?: "min" | "small" | "medium" | "large" | "full";
  height?: "normal" | "small";
  placeholder?: string;
  onChange: (e: any, name: string, item: DropdownOption) => void;
  /**
   * Sužava popis na jednu vrstu i zaključava je pri unosu novog kontakta — korak
   * "Tip kontakta" se tada preskače.
   */
  contactType?: ContactDropdownTypeEnum;
  /**
   * Samo predlaže vrstu pri unosu novog kontakta; popis ostaje neograničen, a korisnik
   * može prebaciti tip. Za polja gdje je jedna vrsta česta, ali ne i jedina.
   */
  defaultContactType?: ContactDropdownTypeEnum;
  /** Sadržaj tooltipa na hover odabranog kontakta — npr. adresa, OIB i IBAN. */
  tooltip?: React.ReactNode;

  /** Filter by contact group IDs */
  contactGroupIds?: string[];
  /** Nudi unos novog kontakta (gumb "+" i "Kreiraj …"). Filteri pretrage ga isključuju. Zadano uključeno. */
  allowCreate?: boolean;
};
